import * as MODES_REGLEMENTS from './modeReglement';
import * as MODES_REGLEMENTS_LIBELLE from './modeReglementLibelle';

export const MODES_REGLEMENTS_POINTAGE = {
  [MODES_REGLEMENTS.CHEQUE]: MODES_REGLEMENTS_LIBELLE.CHEQUE,
  [MODES_REGLEMENTS.NUMERAIRE]: MODES_REGLEMENTS_LIBELLE.NUMERAIRE,
  [MODES_REGLEMENTS.CESU]: MODES_REGLEMENTS_LIBELLE.CESU,
  [MODES_REGLEMENTS.CHEQUE_VAC]: MODES_REGLEMENTS_LIBELLE.CHEQUE_VAC,
  [MODES_REGLEMENTS.CARTE_BANCAIRE]: MODES_REGLEMENTS_LIBELLE.CARTE_BANCAIRE,
  [MODES_REGLEMENTS.VIREMENT]: MODES_REGLEMENTS_LIBELLE.VIREMENT,
  [MODES_REGLEMENTS.PRELEVEMENT]: MODES_REGLEMENTS_LIBELLE.PRELEVEMENT,
  [MODES_REGLEMENTS.CARTE_BANCAIRE_INTERNET]: MODES_REGLEMENTS_LIBELLE.CARTE_BANCAIRE_INTERNET,
  [MODES_REGLEMENTS.PRELEVEMENT_INTERNET]: MODES_REGLEMENTS_LIBELLE.PRELEVEMENT_INTERNET,
  [MODES_REGLEMENTS.TICKET]: MODES_REGLEMENTS_LIBELLE.TICKET,
  [MODES_REGLEMENTS.BON_CCAS]: MODES_REGLEMENTS_LIBELLE.BON_CCAS,
  [MODES_REGLEMENTS.BON_CAF]: MODES_REGLEMENTS_LIBELLE.BON_CAF,
};
